import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';

const NotFoundScreen: React.FC = () => {
  const { currentSport } = useTheme();

  return (
    <div className="not-found-screen">
      <div className="container">
        <div className="not-found-content">
          <h1>404 - Page Not Found</h1>
          <p>Sorry, the page you're looking for doesn't exist.</p>
          <Link to="/" className="back-home-button">
            Back to {currentSport.name} Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFoundScreen;
